import { FileTargetBrandNames, ProductVersionFileKeyNames } from "../../models/domain-enum-mapping";
import { FileTargetBrandDto, ProductVersionFileKeyDto } from "../../models/domain/enums";

export const productVersionFileKeySelectOptions = [
  { value: "Other", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Other] },
  { value: "Updater", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Updater] },
  { value: "Setup", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Setup] },
  { value: "Commit", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Commit] },
  { value: "Metadata", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Metadata] },
  { value: "Manifest", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.Manifest] },
  { value: "ReleaseNotesByCommit", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.ReleaseNotesByCommit] },
  { value: "ReleaseNotes", text: ProductVersionFileKeyNames[ProductVersionFileKeyDto.ReleaseNotes] },
];

export const fileTargetBrandSelectOptions = [
  { value: "Common", text: FileTargetBrandNames[FileTargetBrandDto.Common] },
  { value: "Abs", text: FileTargetBrandNames[FileTargetBrandDto.Abs] },
  { value: "Engs", text: FileTargetBrandNames[FileTargetBrandDto.Engs] },
  { value: "Ingenuity", text: FileTargetBrandNames[FileTargetBrandDto.Ingenuity] },
];